__turbopack_context__.v({
  "footer": "styles-module-scss-module__FwJJCq__footer",
  "header": "styles-module-scss-module__FwJJCq__header",
  "previous_step": "styles-module-scss-module__FwJJCq__previous_step",
  "property_image": "styles-module-scss-module__FwJJCq__property_image",
  "property_images": "styles-module-scss-module__FwJJCq__property_images",
  "property_images_container": "styles-module-scss-module__FwJJCq__property_images_container",
  "step_three": "styles-module-scss-module__FwJJCq__step_three",
});
